/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Page_Title_Workflow_ScheduleInputs */

const en_page_title_workflow_schedule = /** @type {(inputs: Page_Title_Workflow_ScheduleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workflow schedule`)
};

const nl_page_title_workflow_schedule = /** @type {(inputs: Page_Title_Workflow_ScheduleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workflowplanning`)
};

/**
* | output |
* | --- |
* | "Workflow schedule" |
*
* @param {Page_Title_Workflow_ScheduleInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const page_title_workflow_schedule = /** @type {((inputs?: Page_Title_Workflow_ScheduleInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Page_Title_Workflow_ScheduleInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_page_title_workflow_schedule(inputs)
	return en_page_title_workflow_schedule(inputs)
});